"use client"

import Image from "next/image"
import { useState } from "react"
import { cn } from "@/utils/cn"
import { ImageWithFallback } from "./image-with-fallback"
import type { ImagePropsWithFallback } from "./types"

export const RemoteImage = ({
  src,
  quality,
  fallbackSrc,
  className,
  ...props
}: ImagePropsWithFallback) => {
  const [isLoading, setIsLoading] = useState(true)

  return fallbackSrc ? (
    <ImageWithFallback
      {...props}
      src={src}
      fallbackSrc={fallbackSrc}
      placeholder="empty"
      unoptimized
      className={cn(className, isLoading && "loading")}
      onLoad={() => setIsLoading(false)}
      onError={() => setIsLoading(false)}
    />
  ) : (
    <Image
      {...props}
      src={src}
      placeholder="empty"
      unoptimized
      className={cn(className, isLoading && "loading")}
      onLoad={() => setIsLoading(false)}
      onError={() => setIsLoading(false)}
    />
  )
}
